import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadHealthDashboard } from "../../../actions/dashboardAction";
import { setFloor, setBuilding } from "../../../actions/dataActions";
import { getScanInfo } from "../../../actions/3dFusionAction";

const DashboardForm = ({ data, user }) => {
  const dispatch = useDispatch();

  const building = useSelector((state) => state.building.data);
  const floor = useSelector((state) => state.floor.data);
  const dark = useSelector((state) => state.dark.data);
  const buildingImage = useSelector(
    (state) => state.performanceDashboard.data?.buildingImage
  );

  const floorDisplayImage = useSelector(
    (state) => state.performanceDashboard.data?.floorDisplayImage
  );

  return (
    <div className="d-flex flex-column h-100">
      <div className="h-25">
        <div className="row w-100 mb-5 mb-lg-0">
          <div className="col"></div>
          {building && (
            // Select a floor
            <select
              name=""
              id=""
              className="col form-select dashboard-form d-inline mx-2"
              style={{
                background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                  dark ? "white" : ""
                }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
              }}
              onChange={(e) => {
                const selectedFloor = building.floors[e.target.value];
                dispatch(setFloor(selectedFloor));
                if (selectedFloor?.id) {
                  dispatch(getScanInfo(selectedFloor.id));
                }
              }}
            >
              <option>Choose a Floor</option>
              {building.floors.map((f, i) => (
                <option
                  value={i}
                  key={i}
                  selected={floor ? f.id === floor.id : false}
                >
                  {f.floor}
                </option>
              ))}
            </select>
          )}{" "}
          {/* Select Building */}
          <select
            name=""
            id=""
            className="col form-select dashboard-form d-inline "
            onChange={(e) => {
              console.log("test the building value", e.target.value);
              console.log("test the data value", data);
              dispatch(setBuilding(data[e.target.value]));
            }}
            style={{
              background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                dark ? "white" : ""
              }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
            }}
          >
            <option value={null}>Select Building</option>
            {data.map((b, i) => (
              <option
                value={i}
                selected={building ? b.id === building.id : false}
                key={i}
              >
                {b.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {floor && (
        <div className="h-75 mx-auto">
          {/* {building.id === 46 ? (
            <img
              src={floor.displayImage2}
              alt=""
              className="h-75 mx-auto w-100"
            />
          ) : (
            <img
              src={floor.displayImage}
              alt=""
              className="h-75 mx-auto w-100"
            />
          )} */}
          {floorDisplayImage && (
            <>
              <img
                src={floorDisplayImage}
                alt=""
                className="h-75 mx-auto w-100"
              />
              <div className="mt-5 w-100 text-center dashboard-building-name">
                {building.name}
              </div>
            </>
          )}
        </div>
      )}
      {building && !floor && (
        <div className="h-75 mx-auto">
          {/* {building.id === 46 ? (
            <img
              src={building.image2}
              alt=""
              className="h-75 mx-auto w-100"
            />
          ) : (
            <img src={building.image} alt="" className="h-75 mx-auto w-100" />
          )} */}
          {buildingImage && (
            <>
              <img src={buildingImage} alt="" className="h-75 mx-auto w-100" />
              <div className="mt-5 w-100 text-center dashboard-building-name">
                {building.name}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DashboardForm;
